import React from "react";
import pageNotfound from "../assets/svgs/PageNotfound.gif";
import { Link } from "react-router-dom";
const PageNotfound = () => {
  return (
    <div className="page-not-found-container container">
      <img src={pageNotfound} />
      <div className="inner-link">
        <div className="title"> Oops! Page Not Found</div>
        <div className="sub-title">
          The page you're looking for doesn't exist or has been moved.
        </div>
        <div className="link">
          <Link to={"/"}>Go to homepage</Link>
        </div>
      </div>
    </div>
  );
};

export default PageNotfound;
